"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.of = void 0;
const prelude_1 = require("@packages/prelude");
const of = (url) => ({
    method: 'GET',
    url,
    params: {},
    headers: {},
    decoder: prelude_1.t.string
});
exports.of = of;
//# sourceMappingURL=GET.js.map